import styled from 'styled-components';

export const VmoFootnoteContainer = styled.div`
  margin: 20px 0;
  font-size: 14px;
  width: 100%;
  max-width: 100%;
  padding: 0 1.5rem;
  text-align: center;
  display: block;

  .vmo-footnote-content {
    width: 100%;
    text-align: center;
    display: block;
    line-height: 1.4;

    p {
      margin: 10px 0;
      display: block;
      width: 100%;
      line-height: 1.4;

      &:not([style*='text-align']) {
        text-align: center;
      }
    }

    div {
      display: block;
      width: 100%;

      &:not([style*='text-align']) {
        text-align: center;
      }

      /* handle nested divs with existing flex styling - convert to block but preserve alignment */
      &[style*='flex'] {
        display: block !important;
        flex-direction: column !important;
      }
    }

    /* container single column but preserve internal styling */
    > div {
      width: 100%;
    }
  }
`;
